export default __webpack_public_path__ + "static/media/sign-logo-yellow.0aeb3ce9.svg";